import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { Badge } from '../ui/badge';

const TabsContainer = ({ tabs, activeTab, onTabChange, children }) => {
  const activeTabId = tabs[activeTab]?.id || tabs[0]?.id;

  const handleValueChange = (value) => {
    const index = tabs.findIndex(tab => tab.id === value);
    if (index !== -1) {
      onTabChange(index);
    }
  };

  return (
    <Tabs value={activeTabId} onValueChange={handleValueChange} className="w-full">
      {/* На узких экранах вкладки не режем на N равных колонок (текст превращается в кашу),
          а выкладываем в строку с горизонтальным скроллом */}
      <TabsList
        className="flex w-full max-w-full mb-4 h-auto p-1 gap-1 overflow-x-auto justify-start sm:grid sm:overflow-visible sm:mb-6"
        style={{ gridTemplateColumns: `repeat(${tabs.length}, 1fr)` }}
      >
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.id}
            value={tab.id}
            className="flex shrink-0 grow-0 basis-auto items-center gap-1 text-xs py-2 px-2 sm:grow sm:basis-0"
          >
            {tab.icon && <span>{tab.icon}</span>}
            <span>{tab.label}</span>
            {tab.badge && (
              <Badge variant="secondary" className="text-xs ml-1">
                {tab.badge}
              </Badge>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
      
      <TabsContent value={activeTabId} className="mt-0 space-y-6">
        {children}
      </TabsContent>
    </Tabs>
  );
};

export default TabsContainer;
